import React, {useEffect, useState} from 'react';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import {Fab} from "@mui/material";
import {green} from '@mui/material/colors';

const GoTop = () => {
     const scrollToTop = () => {
        setTimeout(() => {
            window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
        }, 50);
    }

    const [showTop,setShowTop] = useState(false);

    useEffect(()=>{
        window.addEventListener('scroll',()=>{
            console.log('scrollY:',window.scrollY);
            if(window.scrollY > 200){
                setShowTop(true)
            } else {
                setShowTop(false)
            }
        })
    },[])
    return (
        <Fab sx={{
            position: 'fixed',
            bottom: showTop ? 16 : -64,
            left: 16,
            transition:'all 500ms',
            bgcolor: green[500],
            filter:`blur(${showTop ? 0 : 20}px)`,
            rotate:`${showTop ? 0 : 720}deg`,
            '&:hover': {
                bgcolor: green[800]
            },
        }} onClick={scrollToTop}>
            <KeyboardDoubleArrowUpIcon sx={{color:"#fff"}}/>
        </Fab>
    );
};

export default GoTop;